'use client'
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { MapContextType, MapProps } from "./types"
import GoogleMapsWrapper from "@/migrated-widgets/table-map/common/GoogleMapsWrapper";
import classNames from "classnames";
import { MapProvider, useMap } from "./MapContext";



interface IRef extends MapContextType {

}

const Map = forwardRef<IRef, MapProps>(function Map({ children, data = [], centerByTags = false, ...mapProps }, ref) {

    const mapRef = useRef<HTMLDivElement>(null);
    const provider = useMap();

    const { setMap, map, markers, centerBy, setGeoData, setDataFunctions } = provider;


    useImperativeHandle(ref, () => provider, [provider]);

    useEffect(() => {
        if (mapRef.current && !map) {
            setMap(new window.google.maps.Map(mapRef.current, mapProps));
        }
    }, [mapRef, map]);

    useEffect(() => {
        if (map) {
            setDataFunctions();
        }
    }, [map]);

    useEffect(() => {
        if (map) {
            setGeoData(data);
        }
    }, [map, data])

    useEffect(() => {
        if (map && centerByTags) {
            const positions: (google.maps.LatLngLiteral | google.maps.LatLngBounds)[] = []
            map.data.forEach((featureCollection) => {
                featureCollection.getGeometry()?.forEachLatLng((latlng) => {
                    positions.push({ lat: latlng.lat(), lng: latlng.lng() })
                })
            })
            markers.forEach((marker) => {
                const _marker = marker.marker;
                if ('getBounds' in _marker) {

                    const bounds = _marker.getBounds();
                    if (bounds)
                        positions.push(bounds);
                } else if ('position' in marker.props) {
                    const position = marker.props.position as google.maps.LatLngLiteral;

                    positions.push({ lat: position?.lat, lng: position?.lng });
                }

            });

            centerBy(positions)
        }
    }, [map, markers, data])

    return (

        <>
            <div className={classNames('w-full', 'h-full')} ref={mapRef}></div>
            {
                map && children
            }
        </>
    )

})

const WrappedMap = forwardRef<IRef, MapProps>(function WrappedMap(props, ref) {
    return (
        <GoogleMapsWrapper>
            <MapProvider>
                <Map {...props} ref={ref} />
            </MapProvider>
        </GoogleMapsWrapper>
    )
})

export default WrappedMap;